import { LoadSpinner } from '@calizahq/react-components-v2'
import React, { useMemo } from 'react'

import { NoResults, Table } from '@/components'
import ListFilter, { FilterTypes } from '@/components/ListFilter/ListFilter'
import { useMobile } from '@/hooks'
import useHomes from '@/hooks/useHomes/useHomes'

import { HomesListColumns, homesMapper } from './Homes.data'
import MobileHomeCard from './MobileHomeCard'

export const Homes = () => {
  const homesQuery = useHomes()
  const homes = homesQuery?.data?.homes

  const { isMobile } = useMobile()

  const data = useMemo(() => {
    return homes ? homesMapper(homes) : []
  }, [homes])

  const columns = useMemo(() => {
    return HomesListColumns
  }, [])

  return (
    <div className="flex w-full flex-col p-4 md:p-8">
      <ListFilter
        hideLengthOfStayFilter={true}
        hideReservationMoveInFilter={true}
        hideReservationMoveOutFilter={true}
        hideSearch={false}
        listType={FilterTypes.HOMES}
        title="Homes"
      />

      {homesQuery?.isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isMobile ? (
            homes && homes?.length > 0 ? (
              homes?.map((home, i) => <MobileHomeCard home={home} key={`${home?.id}${i}`} />)
            ) : (
              <NoResults />
            )
          ) : (
            <Table className={''} columns={columns as any} data={data} />
          )}
        </>
      )}
    </div>
  )
}
